export default __webpack_public_path__ + "assets/images/921778dc678931ee415fa8fb29f1bbbd.png";